@if (options().length > 0) {
    <div class="flex w-full flex-row gap-16">
        <ui-input-select
            class="flex-1"
            [options]="fromOptions()"
            [disabled]="disabled()"
            [selected]="range().from?.toString()"
            [withNullSelect]="withNullSelect()"
            (selectedChange)="$event ? setFrom(+$event) : null"
            label="ab"
        />
        <ui-input-select
            class="flex-1"
            [options]="toOptions()"
            [selected]="range().to?.toString()"
            [disabled]="disabled()"
            [withNullSelect]="withNullSelect()"
            (selectedChange)="$event ? setTo(+$event) : null"
            label="bis"
        />
    </div>
}
